module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "h1c"
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "epub:type": "pagebreak",
      "id": "page_vii",
      "role": "doc-pagebreak"
    }
  }, [_c('strong', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('strong', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_c('strong', [_vm._v("Introduction: Conflict Is Not the Problem")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("Leaders have an opportunity to be a channel for chaos or a catalyst for clarity")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("1")]), _vm._v(" Conflict Capacity: Comfort Is Not a Requirement")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("Skills development that doesn’t lead to embodiment is just a notch above entertainment")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("2")]), _vm._v(" Identity: The Price of Being Too Nice")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("The story that’s been resolved no longer needs to be told")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("3")]), _vm._v(" Leadership Clarity: Staying the Course")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("Leadership identity is about how you see yourself, and leadership clarity is about how you see the situation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("4")]), _vm._v(" Emotional Integrity: Anger Is Not the Truth")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("Think of blame as a shortcut for avoiding responsibility")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("5")]), _vm._v(" Environmental Impact: Structure Determines Behavior")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("Our perceptions and interpretations create structures of knowing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("6")]), _vm._v(" Resistance Training: Working with High-Conflict People")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("Disruptive people will continue to be disruptive as long as no one has the courage to confront them")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "viii",
      "epub:type": "pagebreak",
      "id": "page_viii",
      "role": "doc-pagebreak"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("7")]), _vm._v(" Skills: A Blueprint for Difficult Conversations")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("The answers will come through the conversation, not before the conversation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("8")]), _vm._v(" Responsibility: The Recognition of Choice")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('em', [_vm._v("When you find your choice, you find your power")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Conclusion: It’s Worth It")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/from",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Study Guide and Book Club Facilitation")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0